var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { createSlice, createAsyncThunk, } from "@reduxjs/toolkit";
import { ApiError, ApiErrorType } from "api/errors";
import { getApiGetSystemData, getApiGetSystemsAndFolders, postApiClaimSystemCopy, postApiCreateFolder, postApiCreateSystem, postApiDeleteFolder, postApiDeleteSystem, postApiShareSystemCopy, postApiUpdateFolder, postApiUpdateSystem, postApiSendEmail, postApiCreateConfiguration, getApiGetConfiguration, } from "api/ovm-backend";
import { isSystemInsideFolder } from "store/user/util";
import { UserSessionStorage } from "utility";
export var initialState = {
    activeFolderId: null,
    isLoading: false,
    systems: [],
    folders: [],
};
var setUserId = function (state, action) {
    state.userId = action.payload;
};
var setActiveFolderId = function (state, action) {
    state.activeFolderId = action.payload;
};
var setUserActiveSystem = function (state, action) {
    state.activeSystem = action.payload;
    UserSessionStorage.setActiveSystem(action.payload);
};
var setUserSystems = function (state, action) {
    state.systems = action.payload;
};
var userNotAuthenticatedMessage = {
    message: "User not logged in",
    type: ApiErrorType.NOT_AUTHENTICATED,
    visible: true,
};
var createAuthorizedAsyncThunk = function (thunkApi, callbackThunk) {
    var userId = thunkApi.getState().user.userId;
    if (!userId) {
        return thunkApi.rejectWithValue(userNotAuthenticatedMessage);
    }
    return callbackThunk(userId);
};
var deleteSystem = createAsyncThunk("user/deleteSystem", function (payload, thunkApi) {
    var deleteSystem = function () { return __awaiter(void 0, void 0, void 0, function () {
        var systemId, err_1, error;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    systemId = payload.id;
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, postApiDeleteSystem({
                            body: { id: systemId },
                        })];
                case 2:
                    _a.sent();
                    return [2 /*return*/, {
                            deletedSystemId: systemId,
                        }];
                case 3:
                    err_1 = _a.sent();
                    error = err_1;
                    return [2 /*return*/, thunkApi.rejectWithValue({
                            message: error.message,
                            type: error.type || ApiErrorType.REQUEST_ERROR,
                            extra: error.extra,
                            visible: true,
                        })];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    return createAuthorizedAsyncThunk(thunkApi, deleteSystem);
});
var shareSystem = createAsyncThunk("user/shareSystem", function (payload, thunkApi) {
    var shareSystem = function () { return __awaiter(void 0, void 0, void 0, function () {
        var systemId, shareSystemResponse, err_2, error;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    systemId = payload.id;
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, postApiShareSystemCopy({
                            body: { id: systemId },
                        })];
                case 2:
                    shareSystemResponse = _a.sent();
                    if (shareSystemResponse.response.status >= 400 ||
                        shareSystemResponse.data === undefined) {
                        throw new ApiError("create_system_error", ApiErrorType.UPDATE_SYSTEM);
                    }
                    return [2 /*return*/, {
                            claimId: shareSystemResponse.data.id,
                        }];
                case 3:
                    err_2 = _a.sent();
                    error = err_2;
                    return [2 /*return*/, thunkApi.rejectWithValue({
                            message: error.message,
                            type: error.type || ApiErrorType.REQUEST_ERROR,
                            extra: error.extra,
                            visible: true,
                        })];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    return createAuthorizedAsyncThunk(thunkApi, shareSystem);
});
var sendEmail = createAsyncThunk("user/sendEmail", function (payload, thunkApi) {
    var sendEmail = function () { return __awaiter(void 0, void 0, void 0, function () {
        var subject, message, email, shareSystemResponse, err_3, error;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    subject = payload.subject, message = payload.message, email = payload.toEmail;
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, postApiSendEmail({
                            body: { email: email, subject: subject, message: message },
                        })];
                case 2:
                    shareSystemResponse = _a.sent();
                    if (shareSystemResponse.response.status >= 400) {
                        throw new ApiError("send_email_error", ApiErrorType.SUBMIT_NOT_OK);
                    }
                    return [2 /*return*/];
                case 3:
                    err_3 = _a.sent();
                    error = err_3;
                    return [2 /*return*/, thunkApi.rejectWithValue({
                            message: error.message,
                            type: error.type || ApiErrorType.REQUEST_ERROR,
                            extra: error.extra,
                            visible: true,
                        })];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    return createAuthorizedAsyncThunk(thunkApi, sendEmail);
});
var claimSystem = createAsyncThunk("user/claimSystem", function (payload, thunkApi) {
    var shareSystem = function () { return __awaiter(void 0, void 0, void 0, function () {
        var systemId, userId, claimSystemResponse, err_4, error;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    systemId = payload.id, userId = payload.userId;
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, postApiClaimSystemCopy({
                            body: { id: systemId, userId: userId, folderId: null },
                        })];
                case 2:
                    claimSystemResponse = _a.sent();
                    if (claimSystemResponse.response.status >= 400 ||
                        claimSystemResponse.data === undefined) {
                        throw new ApiError("create_system_error", ApiErrorType.UPDATE_SYSTEM);
                    }
                    return [2 /*return*/, {
                            claimId: claimSystemResponse.data.id,
                        }];
                case 3:
                    err_4 = _a.sent();
                    error = err_4;
                    return [2 /*return*/, thunkApi.rejectWithValue({
                            message: error.message,
                            type: error.type || ApiErrorType.REQUEST_ERROR,
                            extra: error.extra,
                            visible: true,
                        })];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    return createAuthorizedAsyncThunk(thunkApi, shareSystem);
});
var deleteFolder = createAsyncThunk("user/deleteFolder", function (payload, thunkApi) {
    var deleteFolder = function (userId) { return __awaiter(void 0, void 0, void 0, function () {
        var folderId, err_5, error;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    folderId = payload.id;
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, postApiDeleteFolder({
                            body: { id: folderId, userId: userId },
                        })];
                case 2:
                    _a.sent();
                    return [2 /*return*/, {
                            deletedFolderId: folderId,
                        }];
                case 3:
                    err_5 = _a.sent();
                    error = err_5;
                    return [2 /*return*/, thunkApi.rejectWithValue({
                            message: error.message,
                            type: error.type || ApiErrorType.REQUEST_ERROR,
                            extra: error.extra,
                            visible: true,
                        })];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    return createAuthorizedAsyncThunk(thunkApi, deleteFolder);
});
var createSystem = createAsyncThunk("user/createSystem", function (payload, thunkApi) {
    var folderId = payload.folderId !== undefined
        ? payload.folderId
        : thunkApi.getState().user.activeFolderId;
    var createSystem = function (userId) { return __awaiter(void 0, void 0, void 0, function () {
        var imageSrc, name, persistParts, createSystemResponse, getSystemsResponse, err_6, error;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    imageSrc = payload.imageSrc, name = payload.name, persistParts = payload.persistParts;
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 4, , 5]);
                    return [4 /*yield*/, postApiCreateSystem({
                            body: { userId: userId, systemData: persistParts, name: name, imageSrc: imageSrc, folderId: folderId },
                        })];
                case 2:
                    createSystemResponse = _a.sent();
                    if (createSystemResponse.response.status >= 400 ||
                        createSystemResponse.data === undefined) {
                        throw new ApiError("create_system_error", ApiErrorType.UPDATE_SYSTEM);
                    }
                    return [4 /*yield*/, getApiGetSystemsAndFolders({
                            query: { userId: userId },
                        })];
                case 3:
                    getSystemsResponse = _a.sent();
                    if (getSystemsResponse.response.status >= 400 ||
                        getSystemsResponse.data === undefined) {
                        throw new ApiError("load_system_error", ApiErrorType.LOAD_SYSTEM);
                    }
                    return [2 /*return*/, __assign(__assign({}, getSystemsResponse.data), { newSystemId: createSystemResponse.data.id })];
                case 4:
                    err_6 = _a.sent();
                    error = err_6;
                    return [2 /*return*/, thunkApi.rejectWithValue({
                            message: error.message,
                            type: error.type || ApiErrorType.REQUEST_ERROR,
                            extra: error.extra,
                            visible: true,
                        })];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    return createAuthorizedAsyncThunk(thunkApi, createSystem);
});
var saveSystemState = createAsyncThunk("user/saveSystem", function (payload, thunkApi) {
    var saveSystem = function (userId) { return __awaiter(void 0, void 0, void 0, function () {
        var id, imageSrc, name, persistParts, folderId, response, getSystemsResponse, err_7, error;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    id = payload.id, imageSrc = payload.imageSrc, name = payload.name, persistParts = payload.persistParts, folderId = payload.folderId;
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 4, , 5]);
                    return [4 /*yield*/, postApiUpdateSystem({
                            body: __assign(__assign(__assign({ userId: userId, id: id, folderId: folderId }, (persistParts && { systemData: persistParts })), (name && { name: name })), (imageSrc && { imageSrc: imageSrc })),
                        })];
                case 2:
                    response = _a.sent();
                    if (response.response.status >= 400 || response.data === undefined) {
                        throw new ApiError("update_system_error", ApiErrorType.UPDATE_SYSTEM);
                    }
                    return [4 /*yield*/, getApiGetSystemsAndFolders({
                            query: { userId: userId },
                        })];
                case 3:
                    getSystemsResponse = _a.sent();
                    if (getSystemsResponse.response.status >= 400 ||
                        getSystemsResponse.data === undefined) {
                        throw new ApiError("load_system_error", ApiErrorType.LOAD_SYSTEM);
                    }
                    return [2 /*return*/, __assign(__assign({}, getSystemsResponse.data), { updatedSystemId: id })];
                case 4:
                    err_7 = _a.sent();
                    error = err_7;
                    return [2 /*return*/, thunkApi.rejectWithValue({
                            message: error.message,
                            type: error.type || ApiErrorType.REQUEST_ERROR,
                            extra: error.extra,
                            visible: true,
                        })];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    return createAuthorizedAsyncThunk(thunkApi, saveSystem);
});
var saveConfiguration = createAsyncThunk("saveConfiguration", function (payload, thunkApi) {
    var saveConfiguration = function (userId) { return __awaiter(void 0, void 0, void 0, function () {
        var persistParts, response, err_8, error;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    persistParts = payload.persistParts;
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, postApiCreateConfiguration({
                            body: {
                                userId: userId,
                                systemData: persistParts,
                            },
                        })];
                case 2:
                    response = _a.sent();
                    if (response.response.status >= 400 || response.data === undefined) {
                        throw new ApiError("create_system_link_error", ApiErrorType.REQUEST_ERROR);
                    }
                    return [2 /*return*/, { id: response.data.id }];
                case 3:
                    err_8 = _a.sent();
                    error = err_8;
                    return [2 /*return*/, thunkApi.rejectWithValue({
                            message: error.message,
                            type: error.type || ApiErrorType.REQUEST_ERROR,
                            extra: error.extra,
                            visible: true,
                        })];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    return createAuthorizedAsyncThunk(thunkApi, saveConfiguration);
});
var saveFolder = createAsyncThunk("user/saveFolder", function (payload, thunkApi) {
    var save = function (userId) { return __awaiter(void 0, void 0, void 0, function () {
        var id, name, parentId, response, _a, getSystemsResponse, err_9, error;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    id = payload.id, name = payload.name, parentId = payload.parentId;
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 7, , 8]);
                    if (!id) return [3 /*break*/, 3];
                    return [4 /*yield*/, postApiUpdateFolder({
                            body: {
                                userId: userId,
                                id: id,
                                name: name,
                                parentId: parentId,
                            },
                        })];
                case 2:
                    _a = _b.sent();
                    return [3 /*break*/, 5];
                case 3: return [4 /*yield*/, postApiCreateFolder({
                        body: {
                            userId: userId,
                            name: name,
                            parentId: parentId,
                        },
                    })];
                case 4:
                    _a = _b.sent();
                    _b.label = 5;
                case 5:
                    response = _a;
                    if (response.response.status >= 400) {
                        throw new ApiError("update_folder_error", ApiErrorType.SUBMIT_NOT_OK);
                    }
                    return [4 /*yield*/, getApiGetSystemsAndFolders({
                            query: { userId: userId },
                        })];
                case 6:
                    getSystemsResponse = _b.sent();
                    if (getSystemsResponse.response.status >= 400 ||
                        getSystemsResponse.data === undefined) {
                        throw new ApiError("load_system_error", ApiErrorType.LOAD_SYSTEM);
                    }
                    return [2 /*return*/, __assign(__assign({}, getSystemsResponse.data), { updatedSystemId: id })];
                case 7:
                    err_9 = _b.sent();
                    error = err_9;
                    return [2 /*return*/, thunkApi.rejectWithValue({
                            message: error.message,
                            type: error.type || ApiErrorType.REQUEST_ERROR,
                            extra: error.extra,
                            visible: true,
                        })];
                case 8: return [2 /*return*/];
            }
        });
    }); };
    return createAuthorizedAsyncThunk(thunkApi, save);
});
var getUserSystems = createAsyncThunk("user/getUserSystems", function (_, thunkApi) {
    var getUserSystems = function (userId) { return __awaiter(void 0, void 0, void 0, function () {
        var response, err_10, error;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, getApiGetSystemsAndFolders({ query: { userId: userId } })];
                case 1:
                    response = _a.sent();
                    if (response.response.status >= 400 || response.data === undefined) {
                        throw new ApiError("update_folder_error", ApiErrorType.SUBMIT_NOT_OK);
                    }
                    return [2 /*return*/, response.data];
                case 2:
                    err_10 = _a.sent();
                    error = err_10;
                    return [2 /*return*/, thunkApi.rejectWithValue({
                            message: error.message,
                            type: error.type || ApiErrorType.REQUEST_ERROR,
                            extra: error.extra,
                            visible: false,
                        })];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    return createAuthorizedAsyncThunk(thunkApi, getUserSystems);
});
var fetchSystemState = createAsyncThunk("user/fetchSystemState", function (payload, thunkApi) {
    var fetchSystemState = function () { return __awaiter(void 0, void 0, void 0, function () {
        var err_11, error;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 4, , 5]);
                    if (!("configurationId" in payload)) return [3 /*break*/, 2];
                    return [4 /*yield*/, getApiGetConfiguration({
                            query: { id: payload.configurationId },
                        })];
                case 1: return [2 /*return*/, (_a.sent()).data];
                case 2: return [4 /*yield*/, getApiGetSystemData({ query: { id: payload.systemId } })];
                case 3: return [2 /*return*/, (_a.sent())
                        .data];
                case 4:
                    err_11 = _a.sent();
                    error = err_11;
                    return [2 /*return*/, thunkApi.rejectWithValue({
                            message: error.message,
                            type: error.type || ApiErrorType.REQUEST_ERROR,
                            extra: error.extra,
                            visible: true,
                        })];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    return createAuthorizedAsyncThunk(thunkApi, fetchSystemState);
});
var userSlice = createSlice({
    name: "user",
    initialState: initialState,
    reducers: {
        setUserId: setUserId,
        setUserActiveSystem: setUserActiveSystem,
        setUserSystems: setUserSystems,
        setActiveFolderId: setActiveFolderId,
    },
    extraReducers: function (builder) {
        builder.addCase(saveSystemState.fulfilled, function (state, _a) {
            var _b;
            var payload = _a.payload;
            state.isLoading = false;
            state.error = undefined;
            state.systems = payload.systems;
            if (((_b = state.activeSystem) === null || _b === void 0 ? void 0 : _b.id) === payload.updatedSystemId) {
                var activeSystem = state.systems.find(function (system) { return system.id === payload.updatedSystemId; });
                state.activeSystem = activeSystem;
                UserSessionStorage.setActiveSystem(activeSystem);
            }
        });
        builder.addCase(saveSystemState.rejected, function (state, _a) {
            var payload = _a.payload;
            state.error = payload;
            state.isLoading = false;
        });
        builder.addCase(saveSystemState.pending, function (state) {
            state.isLoading = true;
        });
        builder.addCase(getUserSystems.fulfilled, function (state, _a) {
            var payload = _a.payload;
            state.isLoading = false;
            state.error = undefined;
            state.systems = payload.systems;
            state.folders = payload.folders || [];
        });
        builder.addCase(getUserSystems.rejected, function (state, _a) {
            var payload = _a.payload;
            state.error = payload;
            state.isLoading = false;
            state.systems = [];
        });
        builder.addCase(getUserSystems.pending, function (state) {
            state.isLoading = true;
        });
        builder.addCase(fetchSystemState.fulfilled, function (state, _a) {
            var payload = _a.payload;
            state.isLoading = false;
            state.error = undefined;
            state.pendingSystemState = payload;
        });
        builder.addCase(fetchSystemState.rejected, function (state, _a) {
            var payload = _a.payload;
            state.error = payload;
            state.isLoading = false;
            state.pendingSystemState = undefined;
        });
        builder.addCase(fetchSystemState.pending, function (state) {
            state.isLoading = true;
        });
        builder.addCase(deleteSystem.fulfilled, function (state, _a) {
            var _b, _c;
            var payload = _a.payload;
            state.isLoading = false;
            state.error = undefined;
            if (((_b = state.activeSystem) === null || _b === void 0 ? void 0 : _b.id) === payload.deletedSystemId) {
                state.activeSystem = undefined;
                UserSessionStorage.setActiveSystem(undefined);
            }
            state.systems = (_c = state.systems) === null || _c === void 0 ? void 0 : _c.filter(function (system) { return system.id !== payload.deletedSystemId; });
        });
        builder.addCase(deleteSystem.rejected, function (state, _a) {
            var payload = _a.payload;
            state.error = payload;
            state.isLoading = false;
        });
        builder.addCase(deleteSystem.pending, function (state) {
            state.isLoading = true;
        });
        builder.addCase(deleteFolder.fulfilled, function (state, _a) {
            var _b;
            var payload = _a.payload;
            state.isLoading = false;
            state.error = undefined;
            var deletedFolder = state.folders.find(function (folder) { return folder.id === payload.deletedFolderId; });
            if (!deletedFolder)
                return;
            if (((_b = state.activeSystem) === null || _b === void 0 ? void 0 : _b.id) &&
                deletedFolder &&
                isSystemInsideFolder(state.activeSystem, deletedFolder, state.folders)) {
                state.activeSystem = undefined;
                UserSessionStorage.setActiveSystem(undefined);
            }
            state.folders = state.folders.filter(function (folder) { return folder.id !== payload.deletedFolderId; });
        });
        builder.addCase(deleteFolder.rejected, function (state, _a) {
            var payload = _a.payload;
            state.error = payload;
            state.isLoading = false;
        });
        builder.addCase(deleteFolder.pending, function (state) {
            state.isLoading = true;
        });
        builder.addCase(createSystem.fulfilled, function (state, _a) {
            var payload = _a.payload;
            var newSystem = payload.systems.find(function (system) { return system.id === payload.newSystemId; });
            state.isLoading = false;
            state.error = undefined;
            state.activeSystem = newSystem;
            UserSessionStorage.setActiveSystem(newSystem);
        });
        builder.addCase(createSystem.rejected, function (state, _a) {
            var payload = _a.payload;
            state.error = payload;
            state.isLoading = false;
        });
        builder.addCase(createSystem.pending, function (state) {
            state.isLoading = true;
        });
        builder.addCase(saveFolder.fulfilled, function (state, _a) {
            var payload = _a.payload;
            state.isLoading = false;
            state.error = undefined;
            state.systems = payload.systems;
            state.folders = payload.folders || [];
        });
        builder.addCase(saveFolder.rejected, function (state, _a) {
            var payload = _a.payload;
            state.error = payload;
            state.isLoading = false;
        });
        builder.addCase(saveFolder.pending, function (state) {
            state.isLoading = true;
        });
        builder.addCase(shareSystem.fulfilled, function (state) {
            state.isLoading = false;
            state.error = undefined;
        });
        builder.addCase(shareSystem.rejected, function (state, _a) {
            var payload = _a.payload;
            state.error = payload;
            state.isLoading = false;
        });
        builder.addCase(shareSystem.pending, function (state) {
            state.isLoading = true;
        });
        builder.addCase(saveConfiguration.fulfilled, function (state) {
            state.isLoading = false;
            state.error = undefined;
        });
        builder.addCase(saveConfiguration.rejected, function (state, _a) {
            var payload = _a.payload;
            state.error = payload;
            state.isLoading = false;
        });
        builder.addCase(saveConfiguration.pending, function (state) {
            state.isLoading = true;
        });
    },
});
export var allActions = userSlice.actions, reducer = userSlice.reducer;
export var callableActions = {
    saveSystem: saveSystemState,
    saveFolder: saveFolder,
    getUserSystems: getUserSystems,
    setUserActiveSystem: allActions.setUserActiveSystem,
    setUserSystems: allActions.setUserSystems,
    setUserId: allActions.setUserId,
    deleteSystem: deleteSystem,
    deleteFolder: deleteFolder,
    createSystem: createSystem,
    setActiveFolderId: allActions.setActiveFolderId,
    shareSystem: shareSystem,
    saveConfiguration: saveConfiguration,
    claimSystem: claimSystem,
    sendEmail: sendEmail,
    fetchSystemState: fetchSystemState,
};
export default reducer;
